// test332
(332 && 0);
